module.exports = __webpack_public_path__ + "static/media/not_favorite.ebe39c4e.svg";